import { createRouter } from '@tanstack/solid-router'
import { rootRoute } from './__root'
import { appLayoutRoute } from './app-layout.route'

import { indexRoute } from './routes/index.route'
import { wellsRoute } from './routes/wells.route'
import { filesRoute } from './routes/files.route'
import { telemetryRoute } from './routes/telemetry.route'
import { tasksRoute } from './routes/tasks.route'
import { toolsRoute } from './routes/tools.route'
import { statesRoute } from './routes/states.route'
import { fieldsRoute } from './routes/fields.route'
import { casingsRoute } from './routes/casings.route'
import { mudsRoute } from './routes/muds.route'
import { publicStatesRoute } from './routes/public-states.route'
import { settingsRoute } from './routes/settings.route'
import { accountRoute } from './routes/account.route'
import { knbkAssetsRoute } from './routes/knbk-assets.route'

const routeTree = rootRoute.addChildren([
  appLayoutRoute.addChildren([
    indexRoute,
    wellsRoute,
    filesRoute,
    telemetryRoute,
    tasksRoute,
    toolsRoute,
    statesRoute,
    fieldsRoute,
    casingsRoute,
    mudsRoute,
    publicStatesRoute,
    settingsRoute,
    accountRoute,
    knbkAssetsRoute,
  ]),
])

// basepath '/app' — соответствует vite `base: '/app/'`. nginx делает SPA
// fallback на /app/index.html, так что глубокие пути работают при перезагрузке.
export const router = createRouter({
  routeTree,
  basepath: '/app',
  defaultPreload: false,
})

declare module '@tanstack/solid-router' {
  interface Register {
    router: typeof router
  }
}
